import React from 'react';

interface IProps {
  label?: string;
  name?: string;
  id?: string;

  // 이 라디오 버튼이 가지는 고유 값
  value?: string | number;

  // 현재 선택된 값 (그룹 내에서 공유됨)
  selectedValue?: string | number;

  // 변경 시 호출될 함수
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;

  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  readOnly?: boolean;
  error?: string;

  ref?: any;
}

const CustomRadioSingle = (props: IProps) => {
  // 현재 선택된 값과 이 버튼의 값이 같으면 checked
  const isChecked = String(props.value) === String(props.selectedValue);

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.readOnly || props.disabled) return;
    // 라디오 버튼은 선택될 때만 onChange를 호출하는 것이 일반적
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <>
      <div className={`custom-radio-single ${props.className || ''}`} style={props.style}>
        <label htmlFor={props.id}>
          <input
            id={props.id}
            name={props.name}
            type={'radio'}
            value={props.value} // 실제 값 전달
            checked={isChecked}
            onChange={handleOnchange}
            disabled={props.disabled}
            readOnly={props.readOnly}
            ref={props?.ref}
          />
          {props.label}
        </label>

        {props.error && <div className="error-text">{props.error}</div>}
      </div>
    </>
  );
};

export default CustomRadioSingle;
